// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QGlvXY {
  align-items: center;
  display: flex;
  padding: var(--spacing-1) 0;
  border-top: 1px solid var(--stroke-neutral-subtle);
}

.qYHys9 {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-1);
  align-items: center;
  height: 72px;
  justify-content: space-between;
  width: 100%;
  padding: 0 var(--spacing-3);
}

.bwLej3 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-100);
  color: var(--text-neutral-dark);
}

.qwrIQK {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  background: none;
  border: none;
  padding: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-100);
  color: var(--link-default);
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.2s ease;
}

.qwrIQK:hover:not(:disabled) {
  color: var(--icon-primary-dark);
}

.qwrIQK:disabled {
  color: var(--text-neutral-silver);
  text-decoration: none;
  cursor: not-allowed;
}

.gJ4KIF {
  width: var(--spacing-2);
  height: var(--spacing-2);
  color: inherit;
}

.v4hmY1 {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.UcceEy {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-100);
  color: var(--text-neutral-dark);
}

.wbTNSX {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  max-height: 40px;
  padding: 0;
  background: none;
  border: none;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-100);
  color: var(--text-primary-medium);
  cursor: pointer;
}

.g6HHjI {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-100);
  color: #000;
}

.sS5889 {
  border: 1px solid var(--stroke-neutral-subtle);
  width: 1px;
  height: 40px;
  opacity: 1;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/EmissorCardTrackingPage/components/TrackingSummary/TrackingSummary.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,UAAU;EACV,YAAY;EACZ,UAAU;EACV,SAAS;AACX","sourcesContent":[".trackingSummary {\n  align-items: center;\n  display: flex;\n  padding: var(--spacing-1) 0;\n  border-top: 1px solid var(--stroke-neutral-subtle);\n}\n\n.summaryItem {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-1);\n  align-items: center;\n  height: 72px;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0 var(--spacing-3);\n}\n\n.label {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-100);\n  color: var(--text-neutral-dark);\n}\n\n.trackingLink {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  background: none;\n  border: none;\n  padding: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-100);\n  color: var(--link-default);\n  text-decoration: underline;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.trackingLink:hover:not(:disabled) {\n  color: var(--icon-primary-dark);\n}\n\n.trackingLink:disabled {\n  color: var(--text-neutral-silver);\n  text-decoration: none;\n  cursor: not-allowed;\n}\n\n.externalIcon {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n  color: inherit;\n}\n\n.quantityValueGroup {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.quantityValue {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-100);\n  color: var(--text-neutral-dark);\n}\n\n.viewAllButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 24px;\n  max-height: 40px;\n  padding: 0;\n  background: none;\n  border: none;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-100);\n  color: var(--text-primary-medium);\n  cursor: pointer;\n}\n\n.deliveryDate {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-100);\n  color: #000;\n}\n\n.separator {\n  border: 1px solid var(--stroke-neutral-subtle);\n  width: 1px;\n  height: 40px;\n  opacity: 1;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trackingSummary": `QGlvXY`,
	"summaryItem": `qYHys9`,
	"label": `bwLej3`,
	"trackingLink": `qwrIQK`,
	"externalIcon": `gJ4KIF`,
	"quantityValueGroup": `v4hmY1`,
	"quantityValue": `UcceEy`,
	"viewAllButton": `wbTNSX`,
	"deliveryDate": `g6HHjI`,
	"separator": `sS5889`
};
module.exports = ___CSS_LOADER_EXPORT___;
